import React, { useMemo, useState } from "react";
import PDHeadingSection from "./PDHeadingSection";
import PDPropertyDataSection from "./PDPropertyDataSection";
import PDAboutProperty from "./PDAboutProperty";
import PDMapView from "./PDMapView";
// import PDAuctionBazaarPackageCard from "./PDAuctionBazaarPackageCard";
import PDAvailableServicesCard from "./PDAvailableServicesCard";
import PDGallerySection from "./PDGallerySection";
import PDContactAuthorizedOfficer from "./PDContactAuthorizedOfficer";
import HowToStartBidding from "../home/howToStartBidding/HowToStartBidding";
import FAQSection from "../home/faq/FAQSection";
import PDDownloadDocuments from "./PDDownloadDocuments";
// import PDKeyHighlightsCard from "./PDKeyHighlightsCard";
// import PDProjectAmenitiesCard from "./PDProjectAmenitiesCard";
// import PDFurnishingDetailsCard from "./PDFurnishingDetailsCard";
// import PDFloorPlan from "./PDFloorPlan";
import ResidentialProperties from "../home/residentialProperties/ResidentialProperties";
import AcknowledgementCard from "../../..//shadcn/components/custom/AcknowledgementCard";
import { AuthModalWrapper } from "../Auth/AuthModal";

import { useSelector } from "react-redux";
import CustomModalLayout from "../Auth/CustomModalLayout";
import PDKnowMoreAboutPropertyCard from "./PDKnowMoreAboutPropertyCard";
import { bidInterest } from "services";
import PDPublicNoticeAggregationDisclaimer from "./PDPublicNoticeAggregationDisclaimer";
interface PropertyDetailWrapperProps {
  propertyData: any;
  defaultLocation: any;
}

export default function PropertyDetailWrapper({
  propertyData,
  defaultLocation,
}: PropertyDetailWrapperProps) {
  const [authModelOpen, setAuthModelOpen] = useState(false);
  const [acknowledgementOpen, setAcknowledgementOpen] = useState(false);
  const [acknowledgementDetails, setAcknowledgementDetails] = useState({
    name: "",
    mobile: "",
    email: "",
    isFooter: false,
  });
  const isLoggedIn = useSelector((state: any) => state.auth.user);

  const handleInterested = async () => {
    const payload: {
      name: string;
      mobile_number?: string;
      email?: string;
      property_id: string;
    } = {
      name: acknowledgementDetails.name,
      property_id: propertyData.listing_id,
    };

    if (acknowledgementDetails?.mobile?.length === 10) {
      payload.mobile_number = acknowledgementDetails.mobile;
    }

    if (
      acknowledgementDetails.email &&
      acknowledgementDetails?.email?.length > 3
    ) {
      payload.email = acknowledgementDetails.email;
    }

    try {
      await bidInterest(payload);
      setAcknowledgementOpen(false);
    } catch (error) {
      console.error("Error handling bid interest:", error);
    }
  };
  const convertToDecimal = (coord: string): number => {
    const dmsRegex = /^(\d{1,3})°(\d{1,2})'(\d{1,2}(\.\d+)?)$/;
    const nsewRegex = /^([0-9]+(\.[0-9]+)?)\s?[nswe]$/i;

    const match = coord.match(dmsRegex);
    if (match) {
      const degrees = parseFloat(match[1]);
      const minutes = parseFloat(match[2]);
      const seconds = parseFloat(match[3]);
      return degrees + minutes / 60 + seconds / 3600;
    }
    const matchNSEW = coord.match(nsewRegex);
    if (matchNSEW) {
      const decimalCoord = parseFloat(matchNSEW[1]);
      const direction = matchNSEW[0].toLowerCase().slice(-1);
      if (direction === "s" || direction === "w") {
        return -decimalCoord;
      }
      return decimalCoord;
    }

    return parseFloat(coord);
  };

  const locationCoordinates = propertyData?.location_coordinates;
  let coordinates = {
    isCoordinatesFound: false,
    value: ["na", "na"],
  };
  if (
    locationCoordinates &&
    !locationCoordinates?.toLowerCase()?.includes("na") &&
    !locationCoordinates?.toLowerCase()?.includes("no") &&
    !locationCoordinates?.toLowerCase()?.includes("contact no") &&
    !locationCoordinates?.toLowerCase()?.includes("null")
  ) {
    if (locationCoordinates.includes(",")) {
      const foundCoordinates = locationCoordinates
        .split(",")
        .map((coord: string) =>
          coord
            .toString()
            .replace(/[^\d.-]/g, "")
            .trim(),
        )
        .map((coord: string) => {
          return convertToDecimal(coord.replace(/[nesw]/gi, "").trim());
        });
      const cleanCoords = foundCoordinates?.filter(
        (value: any) => !isNaN(value),
      );

      if (Array?.isArray(cleanCoords) && cleanCoords?.length === 2) {
        coordinates = {
          isCoordinatesFound: true,
          value: cleanCoords,
        };
      } else {
        coordinates = {
          isCoordinatesFound: false,
          value: cleanCoords,
        };
      }
    } else if (locationCoordinates && locationCoordinates.includes(" ")) {
      // Handle space-separated coordinates (e.g., 30.89 75.89)
      const foundCoordinates = locationCoordinates
        .split(" ")
        .map((coord: string) =>
          convertToDecimal(
            coord
              .toString()
              .replace(/[^\d.-]/g, "")
              .trim(),
          ),
        );
      const cleanCoords = foundCoordinates?.filter(
        (value: any) => !isNaN(value),
      );
      if (Array?.isArray(cleanCoords) && cleanCoords?.length === 2) {
        coordinates = {
          isCoordinatesFound: true,
          value: cleanCoords,
        };
      } else {
        coordinates = {
          isCoordinatesFound: false,
          value: cleanCoords,
        };
      }
    }
  }

  return (
    <div className="bg-white">
      <div className="lg:hidden">
        <div className="px-customPaddingMobile lg:px-customPadding w-full 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
          <PDHeadingSection
            propertyData={propertyData}
            setAuthModelOpen={setAuthModelOpen}
            setAcknowledgementOpen={setAcknowledgementOpen}
            setAcknowledgementDetails={setAcknowledgementDetails}
          />
          <PDPropertyDataSection propertyData={propertyData} />
          <PDAboutProperty />
          {/* <PDKeyHighlightsCard /> */}
          {/* <PDProjectAmenitiesCard /> */}
          {/* <PDFurnishingDetailsCard /> */}
          {/* <PDFloorPlan /> */}
          <PDMapView
            isCoordinateFound={coordinates.isCoordinatesFound}
            position={coordinates.value}
            locality={{
              isFound: propertyData?.locality?.name ? true : false,
              value: propertyData?.locality?.name
                ? propertyData?.locality?.name
                : null,
            }}
            city={propertyData?.city}
            state={propertyData?.state}
          />
          {/* <PDAuctionBazaarPackageCard /> */}
          <PDKnowMoreAboutPropertyCard
            propertyData={propertyData}
            setAuthModelOpen={setAuthModelOpen}
            setAcknowledgementOpen={setAcknowledgementOpen}
            setAcknowledgementDetails={setAcknowledgementDetails}
          />
          <PDAvailableServicesCard />
        </div>
        <PDGallerySection images={propertyData.images} />
        <div className="px-customPaddingMobile lg:px-customPadding w-full 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
          <PDContactAuthorizedOfficer
            propertyData={propertyData}
            setAuthModelOpen={setAuthModelOpen}
            setAcknowledgementOpen={setAcknowledgementOpen}
            setAcknowledgementDetails={setAcknowledgementDetails}
          />
          <PDDownloadDocuments
            propertyData={propertyData}
            setAuthModelOpen={setAuthModelOpen}
            setAcknowledgementOpen={setAcknowledgementOpen}
            setAcknowledgementDetails={setAcknowledgementDetails}
          />
          <ResidentialProperties defaultLocation={defaultLocation} />
          <HowToStartBidding />
          <FAQSection />
        </div>
      </div>
      <div className="hidden lg:block px-customPaddingMobile lg:px-customPadding w-full 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
        <PDHeadingSection
          propertyData={propertyData}
          setAuthModelOpen={setAuthModelOpen}
          setAcknowledgementOpen={setAcknowledgementOpen}
          setAcknowledgementDetails={setAcknowledgementDetails}
        />
        <PDPropertyDataSection propertyData={propertyData} />
        <div className="grid lg:grid-cols-[minmax(0,1fr)_348px] lg:gap-x-8">
          <div className="order-1" id="px-12235">
            <PDAboutProperty />
          </div>
          <div className="order-5">
            <PDMapView
              isCoordinateFound={coordinates.isCoordinatesFound}
              position={coordinates.value}
              locality={{
                isFound: propertyData?.locality?.name ? true : false,
                value: propertyData?.locality?.name
                  ? propertyData?.locality?.name
                  : null,
              }}
              city={propertyData?.city}
              state={propertyData?.state}
            />
          </div>
          <div className="order-6">
            {/* <PDAuctionBazaarPackageCard /> */}
            <PDKnowMoreAboutPropertyCard
              propertyData={propertyData}
              setAuthModelOpen={setAuthModelOpen}
              setAcknowledgementOpen={setAcknowledgementOpen}
              setAcknowledgementDetails={setAcknowledgementDetails}
            />
          </div>
          <div className="order-7">
            <PDAvailableServicesCard />
          </div>
          <div className="order-8">
            <PDGallerySection images={propertyData.images} />
          </div>
          <div className="order-2 row-span-10">
            <PDContactAuthorizedOfficer
              propertyData={propertyData}
              setAuthModelOpen={setAuthModelOpen}
              setAcknowledgementOpen={setAcknowledgementOpen}
              setAcknowledgementDetails={setAcknowledgementDetails}
            />
            <PDDownloadDocuments
              propertyData={propertyData}
              setAuthModelOpen={setAuthModelOpen}
              setAcknowledgementOpen={setAcknowledgementOpen}
              setAcknowledgementDetails={setAcknowledgementDetails}
            />
            <PDPublicNoticeAggregationDisclaimer />
          </div>
        </div>
        <ResidentialProperties defaultLocation={defaultLocation} />
        <HowToStartBidding />
        <FAQSection />
      </div>
      <AuthModalWrapper
        userLoggedin={isLoggedIn}
        authModelOpen={authModelOpen}
        setAuthModelOpen={setAuthModelOpen}
      />
      <CustomModalLayout
        open={acknowledgementOpen}
        onClose={() => setAcknowledgementOpen(false)}
        childrenClassName="pl-4 pr-6"
        className="pt-8 pb-[30px]"
      >
        <AcknowledgementCard
          name={acknowledgementDetails.name ? acknowledgementDetails.name : ""}
          message="Thank you for your interest in the property. Our team will connect with you soon to provide further details."
          hideBottomActions={
            acknowledgementDetails?.isFooter
              ? !acknowledgementDetails.isFooter
              : true || true
          }
          contactInfo={{
            mobileNumber: `+91 ${acknowledgementDetails?.mobile || ""}`,
            email: acknowledgementDetails?.email || "",
          }}
          handleInterested={handleInterested}
          handleNotInterested={() => setAcknowledgementOpen(false)}
        />
      </CustomModalLayout>
    </div>
  );
}
